import React from "react";

/**
 * Tiny dependency-free SVG sparkline.
 * Props:
 *  - data: number[] (any length, but typically 30 days)
 *  - width, height: SVG dimensions in px
 *  - stroke: line color (default coastal cyan)
 *  - fill: area fill color under the line (default cyan @ 12% alpha)
 */
export default function Sparkline({
  data = [],
  width = 140,
  height = 32,
  stroke = "#0284C7",
  fill = "rgba(2,132,199,0.12)",
}) {
  if (!data.length) return null;
  const max = Math.max(1, ...data);
  const stepX = data.length > 1 ? width / (data.length - 1) : width;
  const padTop = 2;
  const padBottom = 2;
  const usable = height - padTop - padBottom;

  const pts = data.map((v, i) => {
    const x = i * stepX;
    const y = padTop + (usable - (v / max) * usable);
    return [x, y];
  });

  const linePath = pts.map(([x, y], i) => `${i === 0 ? "M" : "L"} ${x.toFixed(2)} ${y.toFixed(2)}`).join(" ");
  const areaPath = `${linePath} L ${width} ${height} L 0 ${height} Z`;

  // Highlight today (last point)
  const last = pts[pts.length - 1];

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      role="img"
      aria-label={`30-day trend, ${data.reduce((a, b) => a + b, 0)} total`}
    >
      <path d={areaPath} fill={fill} />
      <path d={linePath} stroke={stroke} strokeWidth="1.5" fill="none" strokeLinejoin="round" strokeLinecap="round" />
      {last && <circle cx={last[0]} cy={last[1]} r="2.2" fill={stroke} />}
    </svg>
  );
}
